import React, { useContext } from 'react'
import { Formik } from 'formik'
import { Button, Form, Grid, GridCell, NotificationManagerContext, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Select } from 'src/components/ConnectedForm'
import { useInitiativeList, useUpdateNote } from 'src/graphql/hooks'

const NoteMove = ({ onCancelButtonClick, onNoteMove, noteId }) => {
   const { initiativeList } = useInitiativeList({ hasNotes: true })
   const { updateNote } = useUpdateNote()
   const { showNotification } = useContext(NotificationManagerContext)

   const handleMoveNote = async (values, actions) => {
      try {
         await updateNote({ id: noteId }, { initiativeId: values.initiativeId })
         showNotification({
            message: 'Note moved successfully',
            title: 'Success!',
            type: 'success'
         })

         if (onNoteMove) {
            onNoteMove()
         }
      } catch (err) {
         window.alert(err.message)
      }
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            height="55px"
            padding="0px 15px"
            borderBottom="1px solid #eee">
            <Text size="2.5" weight="medium">
               Move Note
            </Text>
         </View>
         <Formik
            initialValues={{ initiativeId: '' }}
            onSubmit={handleMoveNote}
            render={({ handleSubmit, handleChange, isSubmitting }) => (
               <Form
                  elementAppearance="plain"
                  elementBackgroundColor="#eee"
                  elementFocusBackgroundColor="#f5f5f5"
                  onSubmit={handleSubmit}>
                  <View padding="15px">
                     <Text size="2">
                        Select where you want to move this note:
                     </Text>
                     <View marginTop="5px">
                        <Select name="initiativeId">
                           {initiativeList.items.map(initiative => (
                              <option key={initiative.id} value={initiative.id}>
                                 {initiative.name}
                              </option>
                           ))}
                        </Select>
                     </View>
                  </View>
                  <View padding="10px 15px" borderTop="1px solid #eee">
                     <Grid columns="2" spacing="10px">
                        <GridCell>
                           <Button
                              onClick={onCancelButtonClick}
                              width="100%"
                              name="Cancel"
                              color="#fff"
                              size="md"
                              textColor="#666"
                           />
                        </GridCell>
                        <GridCell>
                           <Button
                              width="100%"
                              type="submit"
                              name="Move"
                              color="#333"
                              size="md"
                              textColor="#fff"
                              mode={isSubmitting ? 'loading' : 'normal'}
                           />
                        </GridCell>
                     </Grid>
                  </View>
               </Form>
            )}
         />
      </View>
   )
}

NoteMove.propTypes = {
   onCancelButtonClick: PropTypes.func.isRequired,
   onNoteMove: PropTypes.func,
   noteId: PropTypes.string.isRequired
}

NoteMove.defaultProps = {
   onNoteMove: undefined
}

export default NoteMove
